export default "__VITE_ASSET__DaWl0KpA__"